import script from "./RightSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./RightSidebar.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/modules/RightSidebar.css?vue&type=style&index=0&id=53680fd5&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53680fd5"]])

export default __exports__